// extracted by mini-css-extract-plugin
export default {"popup__title":"inactivityLogoutPopup_popup__title__LNfOe","popup__text":"inactivityLogoutPopup_popup__text__5dfw6","popup__nextBtn":"inactivityLogoutPopup_popup__nextBtn__K0TvF"};